exports.components = {
  "component---src-components-cv-cv-js": () => import("./../../../src/components/CV/cv.js" /* webpackChunkName: "component---src-components-cv-cv-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

